export default "https://cdn.questicon.mathletics.com/assets/images/info-icon-410174a013f90a154c45672aa52f64c3.svg";